import {AppApi} from 'store/customer/api';

interface Sundry {
    id: number;
    brand_id: number;
    customer_id: number;
    job_id: number;
    sundry_category_id: number;
    sundry_item_id: number;
    advanced: number;
    quantity: number;
    brand_name: string;
    code: string;
    full_category_name: string;
    hardware_ref: string;
    stock_status_text: string;
    sundry_item_name: string;
    calculated_price: number;
    total_calculated_price: number;
}

const JobSundryItems = AppApi.injectEndpoints({
    endpoints: (builder) => ({
        getJobSundryItems: builder.query<
            Sundry[],
            {
                jobId: number;
            }
        >({
            query: ({jobId}) => `/sundries/jobitems/${jobId}`,
            transformResponse: (result: {job_sundry_items: Sundry[]}) =>
                result.job_sundry_items,
            providesTags: ['JobSundryItems'],
        }),
        getJobSundryAttributes: builder.query<
            void,
            {
                id: number;
            }
        >({
            query: ({id}) => ({
                url: `/sundries/job_sundry_attributes`,
                method: 'POST',
                body: {
                    id: id,
                },
            }),
            providesTags: ['JobSundryAttributes'],
        }),
        updateJobSundryQuantity: builder.mutation<
            void,
            {
                jobSundryItemId: number;
                quantity: number;
            }
        >({
            query: ({jobSundryItemId, quantity}) => ({
                url: `/sundries/jobitems/${jobSundryItemId}/quantity/${quantity}`,
                method: 'PUT',
            }),
            invalidatesTags: ['JobSundryItems'],
        }),
    }),
});

export const invalidateJobSundryItems = () =>
    JobSundryItems.util.invalidateTags(['JobSundryItems']);

export const invalidateJobSundryAttributes = () =>
    JobSundryItems.util.invalidateTags(['JobSundryAttributes']);

export const {
    useGetJobSundryItemsQuery,
    useGetJobSundryAttributesQuery,
    useUpdateJobSundryQuantityMutation,
} = JobSundryItems;
